import { IProfileField } from "@/shared/api/profilebuilder"
import { FC } from "react"
import { Loader } from "@/shared/ui/loader"
import { AddFormfield, FormField } from "@/features/formbuilder"
import { useUpdateFormbuilderFieldModal } from "@/features/update-formbuilder-field"

interface FormBuilderProps {
    fields: IProfileField[]
    isLoading: boolean
    update: () => void
    formId: string
}

export const FormBuilder: FC<FormBuilderProps> = ({ fields, formId, isLoading, update }) => {
    const { openDeleteFieldModal } = useUpdateFormbuilderFieldModal()
    return (
        <div className="box">
            <div className="box_header font-mediumttf">
                Поля для ввода
            </div>
            <div className="flex flex-col gap-3">
                {Boolean(fields.length) &&
                    fields.map((field, index) => 
                        <FormField handleDelete={() => openDeleteFieldModal(field, update)} index={index} onUpdate={update} key={field.id} field={field}/>
                    )
                }
                {(!Boolean(fields.length) && !isLoading) &&
                    <div className="font-semibold text-lg uppercase text-color-primary">
                        Нет полей для ввода
                    </div>
                }
                {(!Boolean(fields.length) && isLoading) &&
                    <Loader />
                }
                <AddFormfield index={fields.length} formId={formId} update={update} />
            </div>
        </div>
    )
}